function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 68 107"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M65.05 6.308l-5.816-3.357-8.088 14.009 5.815 3.357L65.05 6.308zM60.71.396a2.95 2.95 0 00-4.03 1.08L48.59 15.485a2.95 2.95 0 001.08 4.03l5.815 3.357a2.95 2.95 0 004.03-1.08l8.089-14.009a2.95 2.95 0 00-1.08-4.03L60.709.396zM31.88 63.664l-5.815-3.357-4.934 8.546 5.815 3.358 4.934-8.547zm-4.34-5.912a2.95 2.95 0 00-4.03 1.08l-4.935 8.546a2.95 2.95 0 001.08 4.03l5.816 3.358a2.95 2.95 0 004.03-1.08l4.934-8.547a2.95 2.95 0 00-1.08-4.03l-5.815-3.357z",
  fill: "#1A79A2"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42.46 16.914a4.425 4.425 0 016.045-1.62l11.277 6.511a4.425 4.425 0 011.62 6.045l-7.197 12.467-2.555-1.475 7.197-12.467a1.475 1.475 0 00-.54-2.015L47.03 17.85a1.475 1.475 0 00-2.015.54L24.313 54.246a1.475 1.475 0 00.54 2.015l11.277 6.51a1.475 1.475 0 002.015-.539l5.62-9.735 2.555 1.475-5.62 9.735a4.425 4.425 0 01-6.045 1.62l-11.278-6.511a4.425 4.425 0 01-1.62-6.045L42.46 16.914z",
  fill: "#1A79A2"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.645 52.047a6.511 6.511 0 106.511-11.277 6.511 6.511 0 00-6.511 11.277zm-1.475 2.555a9.462 9.462 0 109.461-16.388 9.462 9.462 0 00-9.461 16.388z",
  fill: "#1A79A2"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M56.058 50.21a1.475 1.475 0 012.06.32c6.107 8.36 6.211 21.277-.196 32.375-3.76 6.511-9.961 10.805-16.62 12.96v9.262a1.475 1.475 0 01-2.95 0v-8.451a33.82 33.82 0 01-5.9.803v7.648a1.475 1.475 0 01-2.95 0v-7.646c-4.2-.192-8.22-1.23-11.558-3.157L.738 84.39a1.475 1.475 0 011.475-2.555l17.206 9.934c3.192 1.843 7.238 2.8 11.556 2.795a30.821 30.821 0 008.444-1.207c6.476-1.863 12.442-5.855 15.948-11.927 5.959-10.321 5.64-21.944.37-29.159a1.475 1.475 0 01.32-2.061z",
  fill: "#1A79A2"
}), React.createElement("path", {
  d: "M17.656 105.128c0-.815.66-1.475 1.475-1.475h32.455a1.475 1.475 0 110 2.95H19.13c-.814 0-1.475-.66-1.475-1.475z",
  fill: "#1A79A2"
})));